import { Component, OnInit, ViewContainerRef, TemplateRef, OnDestroy } from '@angular/core';
import { Globals } from '../../globals';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit, OnDestroy {

    public id: any;
    fmchangePassword: FormGroup
    public cart_id: any
    public connect;
    modalRef: BsModalRef;
    public link: string;
    public token: any = {
        changePassword: "api/changePasswordcustomer"
    }
    constructor(
        public toastr: ToastsManager,
        public fb: FormBuilder,
        vcr: ViewContainerRef,
        public globals: Globals,
        private modalService: BsModalService,
        private routerAct: ActivatedRoute,
        public translate: TranslateService,
        public router: Router
    ) {
        this.toastr.setRootViewContainerRef(vcr);
        this.connect = this.globals.result.subscribe((response: any) => {
            switch (response['token']) {
                case 'changePassword':
                    let type = (response['status'] == 1) ? "success" : (response['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](response['message'], type);
                    break;
                default:
                    break;
            }
        });
    }

    ngOnInit() {
        let data = this.globals.CUSTOMER.get(true);
        this.id = data.id
        this.routerAct.url.subscribe(url => {
            setTimeout(() => {
                this.link = url[0]['path']
                this.cart_id = url[1]['path']
            }, 250);

        })
    }
    ngOnDestroy() {
        this.connect.unsubscribe();
    }
    openModal(template: TemplateRef<any>) {
        this.fmchangePassword = this.fb.group({
            id: this.id,
            password: ''
        })
        this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
    }
    confirm(): void {
        let data = this.fmchangePassword.value;
        this.globals.send({ path: this.token.changePassword, token: 'changePassword', data: data });
        this.modalRef.hide();
    }
    decline(): void {
        this.modalRef.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/frontend/info/info.component.ts